// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__MsZgg","content":"RecentSearches_content__3FNVW"};